import { MODEL_ID, PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

/**
 * Inverse of parseTripo3dMeshSegmentationDefaultData. Builds an openedModel-shaped
 * payload for a just-submitted segmentation run so it can be reopened without an
 * extra API round-trip. Segmentation takes only input_3d, so there are no
 * settings to capture - providerRunAttributes stays empty.
 *
 * @param {Object} state - ThreeDStudio store state (getState())
 * @param {string|number} id - Run id from the generation API response
 * @returns {Object} - openedModel payload accepted by parseTripo3dMeshSegmentationDefaultData
 */
export const buildTripo3dMeshSegmentationDefaultFromState = (state, id) => ({
  id,
  providerKey: PROVIDER.TRIPO3D,
  providerModelId: MODEL_ID.TRIPO3D_MESH_SEGMENTATION_DEFAULT,
  providerRunAttributes: {},
})
